module.exports = __webpack_public_path__ + "assets/images/P-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/P-icon.png
// module id = 1430
// module chunks = 1